import { render, staticRenderFns } from "./document-account-add.vue?vue&type=template&id=75b154cc&scoped=true&"
import script from "./js/document-account-add.js?vue&type=script&lang=js&"
export * from "./js/document-account-add.js?vue&type=script&lang=js&"
import style0 from "./document-account-add.vue?vue&type=style&index=0&id=75b154cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b154cc",
  null
  
)

export default component.exports